export default __webpack_public_path__ + "static/media/title.f98ccb74.jpg";